import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Redirect } from 'react-router-dom';
import Header from '../Components/Header';
import LeftDrawer from '../Components/LeftDrawer';
import { ProtectedRoute } from './protected-routes';
import Transactions from '../Transactions';
import Rates from '../Rates';
import Users from '../Users';

const DashBoard = () => <h3> DashBoard </h3>;

class FullContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      navDrawerOpen: false,
    };
  }

  handleChangeRequestNavDrawer = () => {
    this.setState({
      navDrawerOpen: !this.state.navDrawerOpen,
    });
  };

  render() {
    const { navDrawerOpen } = this.state;
    const paddingLeftDrawerOpen = 230;

    const styles = {
      header: {
        marginLeft: navDrawerOpen ? paddingLeftDrawerOpen : 0,
      },
      container: {
        padding: '40px 20px 20px 15px',
        marginLeft: navDrawerOpen ? paddingLeftDrawerOpen : 0,
      },
    };

    return (
      <div>
        <Header
          styles={styles.header}
          handleOnClick={this.handleChangeRequestNavDrawer}
        />
        {this.state.navDrawerOpen ? (
          <LeftDrawer navDrawerOpen={navDrawerOpen} username="Prymo Admin" />
        ) : null}

        <div style={styles.container}>
          <Switch>
            <ProtectedRoute path="/dashboard" component={DashBoard} />
            <ProtectedRoute path="/transactions" component={Transactions} />
            <ProtectedRoute path="/users" component={Users} />
            <ProtectedRoute path="/rates" component={Rates} />
            <Redirect from="/" to="/dashboard" />
          </Switch>
        </div>
      </div>
    );
  }
}

FullContainer.propTypes = {
  width: PropTypes.number,
};

export default FullContainer;



// WEBPACK FOOTER //
// ./src/views/FullContainer/FullContainer.js